app.service('mainPageView', function(front, searchBox, articleRotator, rankingRotator) {
	const openSearchBox = () => {
		searchBox.open();
	};

	function setEvents() {
		$('body').on('click', '.js-search-field-input', openSearchBox);
	}

	function init() {
		setEvents();
		articleRotator.init();
		rankingRotator.init();
	}

	return {
		init: init
	};
});
